import { BaseService } from './base.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ValidaCupom } from '../viewModel/valida_cupom.model';
import { ResultApi } from '../viewModel/result_api.model';
import { IValidaCupom } from '../interfaces/valida-cupom.interface';

@Injectable({ providedIn: 'root' })
export class CupomService extends BaseService {

    constructor(private httpClient: HttpClient) {
        super(httpClient, 'cupom');
    }

    public async get(): Promise<ResultApi> {
        try {
            // const httpOptions = await this.getHttpOptions();
            const httpOptions = {};
            return this.httpClient
                .get<ValidaCupom>(`${this.path()}`, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }
    }

    public async valida(cupom: string): Promise<ResultApi> {
        try {
            const httpOptions = await this.getHttpOptions();
            return this.httpClient
                .get<ValidaCupom>(`${this.url}/cupom/validarCupom?cupom=${cupom}`, httpOptions)
                .toPromise()
                .then((res: any) => this.response(res))
                .catch((err: any) => err);
        } catch (e) {
            return null;
        }

    }

    public async cupomsSales(): Promise<ResultApi> {
        // const httpOptions = await this.getHttpOptionsSales();
        const httpOptions = {};
        const query = `?q=Select id,Name,Validade__c,Qntde_desconto__c from Cupom__c Where Validade__c >= TODAY`;
        return this.httpClient
            .get<IValidaCupom>(`${this.salesDataUrl}/query/${query}`, httpOptions)
            .toPromise()
            .then((res: any) => {
                if (res) {
                    return new ResultApi().toResult({ status: 202, data: res, error: null });
                }
                return null;
            })
            .catch((err: any) => {
                return err;
            });
    }
    public async validaSales(
        cupom: string,
        minDailyCoupon = 0,
        totalDaily = 0,
        overValueDays = 0,
        hasCustomRule = false
    ): Promise<ResultApi> {
        // const httpOptions = await this.getHttpOptionsSales();
        const httpOptions = {};
        const query = `?q=Select id,Name,Validade__c,Qntde_desconto__c from Cupom__c Where Name='${cupom}' And Validade__c >= TODAY`;
        const cupomValid = totalDaily >= minDailyCoupon;
        return this.httpClient
            // .get<IValidaCupom>(`${this.salesDataUrl}/query/${query}`, httpOptions)
            .get<IValidaCupom>(`${this.salesUrl}/${cupom}`, httpOptions)
            .toPromise()
            .then((res: any) => {
                // TODO LEMBRAR DE TIRAR
                console.log('res => ', res);
                if (res) {
                    if (!hasCustomRule) {
                        return new ResultApi().toResult({ status: 202,  data: res, error: null });
                    }
                    const data = cupomValid
                        ? res
                        : { totalSize: 0, done: true, records: [], couponMessage: `Valido acima de ${overValueDays} diarias` };
                    return new ResultApi().toResult({ status: 202, data, error: null });
                }
                return null;
            })
            .catch((err: any) => {
                console.error('err => ', err);
                const data = { totalSize: 0, done: true, records: [], couponMessage: '' };
                return new ResultApi().toResult({ status: 202, data, error: null });
            });
    }
}
